import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './plugins/element.js';

// 引入 CSS 文件
import 'bootstrap/dist/css/bootstrap.min.css';
// 引入 Bootstrap JavaScript 文件
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'aos/dist/aos.css';
// 引入 AOS JavaScript 文件
import AOS from 'aos';
import './scss/styles.scss';


Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  mounted() {
    // 在根组件中初始化 AOS，确保在所有组件渲染后执行
    AOS.init();
  },
}).$mount('#app');
